require ("utility/l2e_sound.scss");
var CurrentUser = require("lib/account/CurrentUser");
var Cookies = require('js-cookie');
var ReactTooltip = require("react-tooltip");

class L2eSound extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		var newState = this.get_user_cookie()
		if (props.sources) {
			newState['sources'] = this.update_sources(props.sources)
		} else {
			newState['sources'] = []
		}
		newState['adminEnabled'] = this.get_prefs()
		newState['update'] = 0
		this.state = newState
	}

	componentDidMount() {
		this.initSounds()
		if (window.wrL2eSound == undefined) {
			window.wrL2eSound = {};
		}
		window.wrL2eSound.addSource = this.addSource
		window.wrL2eSound.playSound = this.playSound
		window.wrL2eSound.stopSound = this.stopSound
		window.wrL2eSound.stopAllSounds = this.stopAllSounds
		
		window.wrL2eSound.buildStudentSources = this.buildStudentSources
		window.wrL2eSound.removeSources = this.removeSources
	}

	initSounds() {
		if (this.state.sources.length) {
			this.updateVolume(this.state.volume)
			if (this.state.soundEnabled) {
				this.startShouldPlay()	
			}
		}
	}

	addSource(sources,identifier) {
		sources.forEach(function(s){
			if (identifier) {
				s['ref'] = s['ref'] + "_" + identifier
			}
		})
		var newSources = this.state.sources.slice()
		if (sources.constructor === Array) {
			newSources = newSources.concat(this.update_sources(sources))
		} else {
			newSources = newSources.concat(this.update_sources([sources]))
		}
		this.setState({
			sources: newSources 
		});

	}
	update_sources(sources) {
		sources.forEach(function(s){
			if (!s['dynamic_path']) {
				s['dynamic_path'] = dynamicRequire(s["path"].toLowerCase().replace(/\s/g, "_")+ ".mp3")	
			}
		})
		return sources
	}

	get_prefs() {
		if (CurrentUser){
			if (CurrentUser.isAdmin()) {
				return true
			} else {
				var user = CurrentUser.get()
				if (user) {
					if (user.prefs.sound_enabled) {
						return true 
					} else {
						return false
					}
				}
			}
		}
	}
	get_user_cookie() {
		 var sound_enabled = Cookies.get("sound_enabled");
		 var volume = Cookies.get("volume");
		 if (!sound_enabled) {
		 	Cookies.set("sound_enabled", true,{ expires: 10000});
		 	sound_enabled = true 
		 } else {
		 	if (sound_enabled == "true") {
		 		sound_enabled = true
		 	} else {
		 		sound_enabled = false 
		 	}
		 }
		 if (!volume) {
		 	Cookies.set("volume", 1,{ expires: 10000});
		 	volume = 1 
		 } else {
		 	volume = parseFloat(volume)
		 }
		 return {"volume":volume,"soundEnabled":sound_enabled}
    }

	toggleSoundOption() {
		if (this.state.adminEnabled) {
			if(this.state.soundEnabled) {
				this.state.sources.forEach(function(s){
					this.stopSound(s['ref'])
				}.bind(this))
				this.state.soundEnabled = false
				this.state.volume = 0
				this.setState({
					volume:0
				})
				Cookies.set("sound_enabled", false,{ expires: 10000});
				Cookies.set("volume", 0,{ expires: 10000});
				this.updateVolume(0)
			} else {
				this.state.soundEnabled = true
				this.state.volume = 1
				this.setState({volume: 1})
				Cookies.set("sound_enabled", true,{ expires: 10000});
				Cookies.set("volume", 1,{ expires: 10000});
				this.updateVolume(1)
				this.startShouldPlay()
			}
		}
	}

	startShouldPlay() {
		this.state.sources.forEach(function(s){
			if (s['play']) {
				this.playSound(s['ref'])
			} else {
				this.stopSound(s['ref'])
			}
		}.bind(this))
	}
	updateVolume(volume) {
		if (this.state.adminEnabled) {
			this.state.sources.forEach(function(s){
				if (this.refs[s['ref']]) {
					this.refs[s['ref']].volume = volume
				}
			}.bind(this))
			Cookies.set("volume", volume,{ expires: 10000});
		} else {
			this.state.sources.forEach(function(s){
				this.refs[s['ref']].volume = 0
			}.bind(this))
		}
	}
	playSound(ref) {
		if (this.refs[ref] && this.state.adminEnabled && this.state.soundEnabled) {
			this.refs[ref].currentTime = 0
			var promise = this.refs[ref].play()
			if (promise !== undefined) {
			  promise.catch(error => {
			  	this.handleAutoPlayFail()
			  });
			}
		} 
	}
	handleAutoPlayFail() {
		this.setState({
			soundEnabled:false,
			volume:0
		}, this.triggerTooltip.bind(this,this.refs.mainButton))
	}
	triggerTooltip(ref) {
		ReactTooltip.show(ref)
		setTimeout(ReactTooltip.hide.bind(this,ref), 4000)
	}
	stopAllSounds() {
		Object.keys(this.refs).forEach(function(ref){
			if (ref != "mainButton") {
				this.stopSound(ref)
			}
		}.bind(this))
	}
	stopSound(ref) {
		if (this.refs[ref]) {
			this.refs[ref].pause()	
		}
	}

	volumeUp() {
		var volume = this.state.volume 
		volume += 0.21 
		if (volume > 1){
			volume = 1
		}
		this.updateVolume(volume)
		this.setState({volume: volume})
	}

	volumeDown() {
		var volume = this.state.volume 
		volume -= 0.21 
		if (volume < 0){
			volume = 0
		}
		this.updateVolume(volume)
		this.setState({volume: volume})
	}
	waitForUpdate() {
		setTimeout(function(){
			if(this.state.update) {
				this.waitForUpdate()
			}
		}.bind(this),300)
	}
	checkExistence(item,key) {
		for (var i=0;i<this.state.sources.length;i++){
			if (this.state.sources[i][key].includes(item)) {
				return true
			}
		}
		return false
	}
	buildStudentSources(username,perks) {
		if (this.state.update){
			this.waitForUpdate()
		}
		// Directly updates the state on purpose
		this.state.update = true
		var sound_sources = []
		if (perks.owl_hoots) {
			sound_sources.push({"ref":perks.owl_hoots + "_" + username,"path":"owl_hoots/" + perks.owl_hoots,"play":false})	
		}
		if (!this.checkExistence('background','path')){
			if (perks.background_sounds) {
				sound_sources.push({"ref":perks.background_sounds+ "_" + username,"path":"background/" +perks.background_sounds,"play":true,"loop":true})	
			}
		}
		var depency = false
		// Check if greeting sound not already registered
		if (!this.checkExistence('dances','path')){
			if (perks.greetings && ["Mambo","Swing","Tango"].includes(perks.greetings)) {
				sound_sources.push({"ref":perks.greetings+ "_" + username,"path":"dances/" +perks.greetings,"play":false})	
			}
		}
		sound_sources = this.update_sources(sound_sources)
		// Directly updates the state  on purpose
		this.state.sources = this.state.sources.concat(sound_sources)
		this.setState({
			update:  false
		},function(){
			this.initSounds()
		}.bind(this));
	}
	
	removeSources(username) {
		if (this.state.update){
			this.waitForUpdate()
		}
		// Directly updates the state  on purpose 
		this.state.update = true
		function checkUsername(source) {
			return source['ref'].indexOf(username) == -1 
		}
		// Directly updates the state  on purpose
		this.state.sources = this.state.sources.filter(checkUsername)
		this.setState({
			update: false
		});
	}

	render() {
		if (this.state.sources.length) {
			var audio_sources = []
			var inModal = ""
			if (this.props.inModal) {
				inModal = "-modal"
			}
			this.state.sources.forEach(function(s,i){
				if (s['loop']) {
					audio_sources.push(
						<audio controls key={i} className="sound_controller" ref={s['ref']} id={s['ref']} loop>
							<source src={s['dynamic_path']} type="audio/mp3"/>
							Your browser does not support the audio element.
						</audio>
					)

				} else {
					audio_sources.push(
						<audio controls key={i} className="sound_controller" ref={s['ref']} id={s['ref']}>
							<source src={s['dynamic_path']} type="audio/mp3"/>
							Your browser does not support the audio element.
						</audio>
					)
				}
			})
			if (this.state.adminEnabled) {
				if(this.state.soundEnabled) {
					if (this.state.volume > 0.6) {
						var volume_class = "glyphicon-volume-up"
						var main_button_tip = "Turn sound off"
					} else if(this.state.volume > 0){
						var volume_class = "glyphicon-volume-down"
						var main_button_tip = "Turn sound off"
					}  else {
						var volume_class = "glyphicon-volume-off"
						var main_button_tip = "Click on the + to increase your volume"	
					}
					
					var plusButton = <span className="glyphicon soundOption b-tooltip glyphicon-plus" id={'plusButton'+inModal} data-tip="Increase volume" onClick={this.volumeUp}></span>
					var minusButton = <span className="glyphicon soundOption b-tooltip glyphicon-minus" id={'minusButton'+inModal} data-tip="Lower volume" onClick={this.volumeDown}></span>
				} else {
					var volume_class = "glyphicon-volume-off"
					var main_button_tip = "Turn sound on"
				}
			} else {
				var volume_class = "glyphicon-volume-off"
				var main_button_tip = "Your teacher turned sound off"
			}
			return (
				<div className="l2e_sound hideOnPrint">
					<span ref="mainButton" className={"glyphicon soundOption b-tooltip "+volume_class} id={'mainButton'+inModal} data-tip={main_button_tip} onClick={this.toggleSoundOption}></span>
					{plusButton}
					{minusButton}
					{audio_sources}
					<ReactTooltip effect="solid" />
				</div>
			);
		} else {
			return null
		}
	}
}

L2eSound.propTypes = StrictPropTypes({
	// used for twitter text (and possibly Pinterest)
	sources: PropTypes.array,
	inModal: PropTypes.bool
});

module.exports = L2eSound;



// WEBPACK FOOTER //
// ./modules/components/utility/L2eSound.js